import { initAdultsOnly, setAdultsOnly } from '@modules/adultsOnly';
import { useDispatch } from '@stores';
import { IStoreAdultsOnly } from '@types';
import { useCallback } from 'react';

const useAdultsOnlyActions = () => {
  const dispatch = useDispatch();

  const onInitAdultsOnly = useCallback(() => {
    dispatch(initAdultsOnly());
  }, [dispatch]);

  const onSetAdultsOnly = useCallback(
    (payload: Partial<IStoreAdultsOnly>) => {
      dispatch(setAdultsOnly(payload));
    },
    [dispatch]
  );

  return { onInitAdultsOnly, onSetAdultsOnly };
};

export default useAdultsOnlyActions;
